// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../variables.css\"","mobile-threshold-width":"610px","textField":"PasswordManagerModal_textField__37LaS","errorText":"PasswordManagerModal_errorText__1TfZ2"};